








































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { SupportFeatureAnalytics } from "@/http/api/v2/supporter/featureAnalytics";
import {
  SupportFeatureAnalyticsDto,
  SupportFeatureAnalyticsOptionDto,
} from "@/http/dto/featureAnalytics";

const HotelModule = namespace("HotelModule");

const emptyData = (): SupportFeatureAnalyticsDto => ({
  periodDays: 30,
  periodStart: "",
  periodEnd: "",
  operatingHotelCount: 0,
  activeHotelCount: 0,
  repeatHotelCount: 0,
  activeUserCount: 0,
  sessionCount: 0,
  viewCount: 0,
  filterUseCount: 0,
  issueOpenCount: 0,
  statusChangeCount: 0,
  trackedIssueActionCount: 0,
  classifiedIssueActionCount: 0,
  classifiedIssueActionRate: 0,
  adoptionRate: 0,
  repeatHotelRate: 0,
  filterConversionRate: 0,
  issueOpenConversionRate: 0,
  statusChangeConversionRate: 0,
  daily: [],
  statusUsage: [],
  periodUsage: [],
  overdueUsage: [],
  hotels: [],
  actionPlatforms: [],
  actionHotels: [],
});

@Component
export default class FeatureAnalyticsPage extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;

  periodDays = 30;
  loading = false;
  errorMessage = "";
  data: SupportFeatureAnalyticsDto = emptyData();

  get hotelObjectIdValue() {
    return this.hotelObjectId;
  }

  @Watch("hotelObjectIdValue")
  hotelChanged() {
    this.load();
  }

  get hasActivity() {
    return this.data.daily.some(
      item => item.filterUses > 0 || item.issueOpens > 0 || item.statusChanges > 0,
    );
  }

  get visibleDaily() {
    return this.data.daily;
  }

  get dailyMaximum() {
    return Math.max(
      ...this.data.daily.map(item =>
        Math.max(item.filterUses, item.issueOpens, item.statusChanges),
      ),
      1,
    );
  }

  get statusOptions(): SupportFeatureAnalyticsOptionDto[] {
    return ["0", "1", "3"]
      .map(key => this.data.statusUsage.find(item => item.key === key) || { key, count: 0 })
      .filter(item => item.count > 0 || this.data.statusUsage.length > 0);
  }

  get columns() {
    return [
      {
        title: "호텔",
        dataIndex: "hotelName",
        width: 250,
        scopedSlots: { customRender: "hotel" },
        sorter: (a: any, b: any) => a.hotelName.localeCompare(b.hotelName, "ko"),
      },
      { title: "사용자", dataIndex: "activeUsers", width: 100, sorter: (a: any, b: any) => a.activeUsers - b.activeUsers },
      { title: "사용일", dataIndex: "activeDays", width: 100, sorter: (a: any, b: any) => a.activeDays - b.activeDays },
      { title: "조회", dataIndex: "views", width: 100, sorter: (a: any, b: any) => a.views - b.views },
      { title: "필터", dataIndex: "filterUses", width: 100, sorter: (a: any, b: any) => a.filterUses - b.filterUses },
      { title: "이슈 열람", dataIndex: "issueOpens", width: 110, sorter: (a: any, b: any) => a.issueOpens - b.issueOpens },
      { title: "상태 변경", dataIndex: "statusChanges", width: 110, sorter: (a: any, b: any) => a.statusChanges - b.statusChanges },
      { title: "최근 사용", dataIndex: "lastUsedTime", width: 165, scopedSlots: { customRender: "lastUsedTime" }, sorter: (a: any, b: any) => moment(a.lastUsedTime).valueOf() - moment(b.lastUsedTime).valueOf() },
    ];
  }

  get actionHotelColumns() {
    return [
      {
        title: "호텔",
        dataIndex: "hotelName",
        width: 260,
        scopedSlots: { customRender: "actionHotel" },
        sorter: (a: any, b: any) => a.hotelName.localeCompare(b.hotelName, "ko"),
      },
      { title: "웹", dataIndex: "web", width: 90, sorter: (a: any, b: any) => a.web - b.web },
      { title: "Android", dataIndex: "android", width: 100, sorter: (a: any, b: any) => a.android - b.android },
      { title: "iOS", dataIndex: "ios", width: 90, sorter: (a: any, b: any) => a.ios - b.ios },
      { title: "미확인", dataIndex: "unknown", width: 90, sorter: (a: any, b: any) => a.unknown - b.unknown },
      { title: "합계", dataIndex: "total", width: 90, sorter: (a: any, b: any) => a.total - b.total },
      {
        title: "최근 사용",
        dataIndex: "lastUsedTime",
        width: 165,
        scopedSlots: { customRender: "actionLastUsedTime" },
        sorter: (a: any, b: any) => moment(a.lastUsedTime).valueOf() - moment(b.lastUsedTime).valueOf(),
      },
    ];
  }

  get pagination() {
    return {
      pageSize: 20,
      showSizeChanger: false,
      showTotal: (total: number) => `총 ${this.number(total)}개 호텔`,
    };
  }

  get actionHotelPagination() {
    return {
      pageSize: 10,
      showSizeChanger: false,
      showTotal: (total: number) => `총 ${this.number(total)}개 호텔`,
    };
  }

  mounted() {
    this.load();
  }

  async load() {
    try {
      this.loading = true;
      this.errorMessage = "";
      this.data = await SupportFeatureAnalytics.getIssueStatusDashboard({
        periodDays: this.periodDays,
        hotelObjectId: this.hotelObjectId || undefined,
      });
    } catch {
      this.errorMessage = "기능 사용 현황을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }

  number(value: number) {
    return Number(value || 0).toLocaleString("ko-KR");
  }

  percent(value: number) {
    return `${Number(value || 0).toFixed(1)}%`;
  }

  barHeight(value: number) {
    return Math.max((Number(value || 0) / this.dailyMaximum) * 100, value > 0 ? 4 : 0);
  }

  dayLabel(value: string) {
    return moment(value).format("M/D");
  }

  dateTime(value: string) {
    return value ? moment(value).format("YYYY.MM.DD HH:mm") : "-";
  }

  statusLabel(value: string) {
    return ({ "0": "새이슈", "1": "진행중", "3": "보류중" } as any)[value] || value;
  }

  platformLabel(value: string) {
    return ({ web: "웹", android: "Android 앱", ios: "iOS 앱", unknown: "미확인" } as any)[value] || value;
  }
}
